import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmBarrelMakeForm from '../../../components/forms/FirearmBarrelMakeForm';
import { useFirearmBarrelMakeById, useUpdateFirearmBarrelMake } from '../../../hooks/useFirearmBarrelMakeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmBarrelMakeDTO } from '../../../services/apiClient';

const FirearmBarrelMakeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmBarrelMakeById(id!);
  const updateFirearmBarrelMake = useUpdateFirearmBarrelMake();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Barrel Makes', href: '/admin/firearmbarrelmakes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmBarrelMake.mutateAsync({ id: id!, data });
      navigate('/admin/firearmbarrelmakes');
    } catch (error) {
      console.error('Error updating FirearmBarrelMake:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmbarrelmakes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmBarrelMake.Edit'
    >
        {entityData ? (
          <FirearmBarrelMakeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmbarrelmakes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmBarrelMakeEdit;